import { Box, IconButton } from '@mui/material';
import { DeleteIcon } from '@/shared/ui/display/EmojiIcon';
import { ReactNode } from 'react';
import { useAdvancedSearchTheme } from '@/shared/ui/search/AdvancedSearch/theme/useAdvancedSearchTheme';

interface IProps {
  children: ReactNode;
  onDelete?: () => void;
}

export function FilterRow({ children, onDelete }: IProps) {
  const { filterRowSx, getDangerButtonSx } = useAdvancedSearchTheme();

  return (
    <Box sx={filterRowSx}>
      {children}
      {onDelete && (
        <IconButton size="small" onClick={onDelete} sx={getDangerButtonSx()}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}
